const STORAGE_KEY = "refundManagement_listFilters_v1";

export type PersistedRefundListFilters = {
  hub: string;
  paymentStatus: string;
  /** Single field: booking ID, user name, or mobile (see split in page) */
  searchQuery: string;
  /** YYYY-MM-DD or null */
  rideCompletionDate: string | null;
  page: number;
  rowsPerPage: number;
};

export function loadRefundListFilters(): PersistedRefundListFilters | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<PersistedRefundListFilters> & {
      bookingMasterId?: string;
      username?: string;
      mobileNumber?: string;
      /** @deprecated replaced by refundType */
      paymentStatus?: string;
    };
    if (typeof parsed !== "object" || parsed === null) return null;
    const legacySearch =
      typeof parsed.searchQuery === "string"
        ? parsed.searchQuery
        : ([
            typeof parsed.bookingMasterId === "string"
              ? parsed.bookingMasterId
              : "",
            typeof parsed.username === "string" ? parsed.username : "",
            typeof parsed.mobileNumber === "string" ? parsed.mobileNumber : "",
          ].find((s) => s.trim().length > 0) ?? "");

    const paymentStatusPersisted =
      typeof parsed.paymentStatus === "string"
        ? parsed.paymentStatus
        : typeof parsed.paymentStatus === "string"
          ? parsed.paymentStatus
          : "";

    return {
      hub: typeof parsed.hub === "string" ? parsed.hub : "",
      paymentStatus: paymentStatusPersisted,
      searchQuery: legacySearch,
      rideCompletionDate:
        typeof parsed.rideCompletionDate === "string" ||
        parsed.rideCompletionDate === null
          ? parsed.rideCompletionDate
          : null,
      page:
        typeof parsed.page === "number" && Number.isFinite(parsed.page)
          ? Math.max(0, Math.floor(parsed.page))
          : 0,
      rowsPerPage:
        typeof parsed.rowsPerPage === "number" &&
        Number.isFinite(parsed.rowsPerPage)
          ? Math.max(1, Math.floor(parsed.rowsPerPage))
          : 10,
    };
  } catch {
    return null;
  }
}

export function saveRefundListFilters(state: PersistedRefundListFilters): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // quota / private mode
  }
}
